<!--
 * @Author: your name
 * @Date: 2020-08-12 16:08:47
 * @LastEditTime: 2022-10-27 14:27:25
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/PyInput/index.vue
-->
<style scoped lang="sass">
$primaryColor: rgba(51, 68, 85, 0.45)
.container
  padding-top: 19px

::v-deep
  .container
    .input
      height: 30px
      padding: 0
      font-size: 16px
      color: rgba(51, 68, 85, 1)
      line-height: 30px
      border-bottom: 1px solid #D4D4D4 !important
      border-radius: 0

  .contact_container
    .input
      height: 22px
      padding: 0
      font-size: 17px
      color: rgba(51, 68, 85, 1)
      line-height: 30px
      border: none !important
      background: #F7F7F7
      border-radius: 0

    .label
      left: 0
      height: 20px
      line-height: 19px
      font-size: 16px
      color: rgba(51, 68, 85, 0.45)

  .container
    .label
      left: 0
      height: 20px
      line-height: 19px
      font-size: 13px
      color: rgba(51, 68, 85, 0.45) !important

  .bar::before
    width: 0 !important

  .bar::after
    width: 0 !important

  .push-from-bottom
    font-size: 13px !important
    bottom: 10px !important

  .small_icon
    width: auto
    height: auto
    margin: 0 14px 0 0
    background: #F7F7F7 !important

.no_contact
  ::v-deep
    .contact_container
      .input
        height: 30px
        font-size: 16px

    .container
      .label
        font-size: 16px

    .push-from-bottom
      font-size: 12px !important
      bottom: 30px !important
</style>

<template lang="pug">
.py_input(:class="{ no_contact: !isContact }")
  ContactVueMaterialInputBoxPy(
    v-if="isContact"
    v-bind="$attrs"
    v-on="$listeners"
    :name="name"
    :maxlength="maxlength"
    :value="value"
    :label="title"
    :placeholder="placeholder"
    :type="type"
    background-color="#FFF"
    style="color: #000"
    @input="onChange"
    @pyBlur="handleBlur"
  )
    small-icon(slot="icon" size="" :icon='icon')

  VueMaterialInputBoxPy(
    v-else
    :name="name"
    :maxlength="maxlength"
    :value="value"
    :label="title"
    :placeholder="placeholder"
    :type="type"
    :isContact="isContact"
    background-color="#FFF"
    @input="onChange"
    @pyBlur="handleBlur"
    :disabled="disabled"
    style="color: #000"
    v-bind="$attrs"
    v-on="$listeners"
  )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import Emitter from 'utils/emitters'
import SmallIcon from 'components/SmallIcon'

@Component({
  name: 'PyInput',
  mixins: [Emitter],
  components: {
    SmallIcon
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    maxlength: {
      type: String,
      default: '19'
    },
    inputType: {
      type: String,
      default: ''
    },
    title: {
      type: String
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    isContact: { // Is it the contact page   // 是不是 Contact 页面
      type: Boolean
    },
    icon: { // Icon // 图标
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: { // font size   // 字体大小
      type: [String, Number]
    }
  }
})

class PyInput extends Vue {
  content = ''

  onChange(val) {
    this.$emit('change', val)
    this.dispatch('PyFormItem', 'on-form-change', val)
  }

  handleBlur (val) {
    this.$emit('pyBlur', val)
    this.dispatch('PyFormItem', 'on-form-blur', val)
  }
}

export default PyInput
</script>
